module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Schaffhausen-7174c2a38e784d2fd72da34cafe33baa.png";